const get_bank_features = "/common/features";

export const CONFIG_FEATURES_ROUTES = {
  GET_BANK_FEATURES: get_bank_features,
};
